import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { ensureLoaded } from '@/lib/ensure-loaded';
import { negotiatorPageQuery, negotiatorsQuery } from '@/services/negotiators';
import { parseBuilderSearch, type BuilderSearch } from '@/features/negotiator-builder/builder-search';
import { NegotiatorBuilderRoute } from '@/features/negotiator-builder/builder-route';

export const Route = createFileRoute('/_authed/negotiators')({
  // `negotiator`: whose page (penny, wilder, calco, or one the team made), `dress` its robot view open, `view=changes`
  // its column on Every change; `new`: Create
  // negotiator (`name`, `start`: what Draper's link filled in).
  validateSearch: (search: BuilderSearch & SearchSchemaInput): BuilderSearch => parseBuilderSearch(search),
  loaderDeps: ({ search }) => ({ negotiator: search.negotiator }),
  // The team's negotiators, and the one on the page, read before the page draws (one it hasn't got is the page's to say).
  loader: async ({ context: { queryClient, team }, deps }) => {
    if (!team) return;
    await Promise.all([
      ensureLoaded(queryClient, negotiatorsQuery(team.id)).catch(() => null),
      deps.negotiator ? ensureLoaded(queryClient, negotiatorPageQuery(team.id, deps.negotiator)).catch(() => null) : null,
    ]);
  },
  component: NegotiatorsRoute,
});

function NegotiatorsRoute() {
  const { negotiator, dress, view, new: isNew, name, start } = Route.useSearch();
  return <NegotiatorBuilderRoute negotiator={negotiator} dress={dress === true} view={view} isNew={isNew === true} name={name} start={start} />;
}
